import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import SelectSearch, { fuzzySearch, useSelect } from 'react-select-search';
import { getAllClassesBySchool, getAllSchoolsForStudent, loginThisStudent } from './Api';
import './loginpage.css';
import {studentState} from '../../Atom';
import { useRecoilState } from 'recoil';
import banner from '../../../assets/imgs/login_banner.jfif'
import logo from '../../assets/images/logo.png';

const classes = {
  input: "text-in",
  select: "text-in",
}
function Home() {
  const [authUser, setAuthUser] = useRecoilState(studentState);

  const [schools, setSchools] = useState([])
  const [curentSchool, setCurentSchool] = useState(null)

  const [sClasses, setSClasses] = useState([])
  const [curentSClass, setCurentSClass] = useState(null)

  const [clicked, setClicked] = useState(false)

  const [userData, setUserData] = useState({loginId:"", password:"",classId:""})
  useEffect(() => {
    getAllSchools()
  }, [])
  useEffect(() => {
    if(curentSchool){
      getAllSClasses(curentSchool)
    }
  }, [curentSchool])
  const getAllSchools = async () => {
    const res = await getAllSchoolsForStudent()
    
    let tempSchool = res.res.data.data.schools.map(item => {
      return {
        value: item._id,
        name: item.name
      }
    })
    setSchools(tempSchool)
  }
  const getAllSClasses = async (sClassId) => {
    const res = await getAllClassesBySchool(sClassId)
    ////console.logres.res.data.data)
    let tempClasses = res.res.data.data.sclasses.map(item => {
      return {
        value: item._id,
        name: item.name
      }
    })
    setSClasses(tempClasses)
  }
  const handleSubmit = async (event) => {
    event.preventDefault()
    
    // if(!curentSchool){
    //   alert("Select School")
    //   return
    // }
    // if(!curentSClass){
    //   alert("Select Class/Grade")
    //   return
    // }
    setClicked(true)
    const res = await loginThisStudent({
      // sclassId: curentSClass,
      // schoolId: curentSchool,
      // ...userData
      loginId:userData.loginId.trim(),
      password:userData.password.trim(),
      classId:userData.classId.trim()
    })
    setClicked(false)
    ////console.log'Login res',res)
    if(!res.error){
      
      ////console.logres.res.data.data)
      setAuthUser({
        token:res.res.data.data.token,
        userId:res.res.data.data.userId,
        loginId:res.res.data.data.loginId,
        className:res.res.data.data.className,
        teacher:res.res.data.data.teacher,
        classId:res.res.data.data.sclassId,
        passChange:res.res.data.data.passwordChange
      })
    }else{
      alert("Invalid Credentials!")
    }
  }
  return (
    <div>
      <div className="student-container">
            <div className='logo'>
                <img src={logo} alt="SpaceTrex" />
            </div>
        <div className="components">
      <div className="login-container">
          <div className="login-content">
          Test engines like <br/> real rocket scientists   
          </div>
          <form className="form login-form" onSubmit={(e)=>handleSubmit(e)}>
            <h1>Welcome, Student</h1>
            <div className="login-input">
                {/* <select className="text-in" style={{textTransform:'capitalize'}} required onChange={(e)=>{setCurentSchool(e.target.value)}} >
                    <option value={null} style={{textTransform:'capitalize'}}>Select School</option>
                    {schools.map(item => {
                      return <option value={item.value} style={{textTransform:'capitalize'}}>{item.name}</option>
                    })}
                </select>
                <select className="text-in" style={{textTransform:'capitalize'}} required onChange={(e)=>{setCurentSClass(e.target.value)}} >
                    <option value={null} style={{textTransform:'capitalize'}}>Select Class/Grade</option>
                    {sClasses.map(item => {
                      return <option value={item.value} style={{textTransform:'capitalize'}}>{item.name}</option>
                    })}
                  </select> */}
                  <input type="text" className="text-in" onBlur={e=>setUserData({...userData, classId:e.target.value.trim()})} 
                  placeholder="Enter Class Id" required onChange={e=>setUserData({...userData, classId:e.target.value})} value={userData.classId}/>
                  <input type="text" className="text-in" placeholder="Enter Student Id" required onBlur={e=>setUserData({...userData, loginId:e.target.value.trim()})} 
                  onChange={e=>setUserData({...userData, loginId:e.target.value})} value={userData.loginId}/>
                  <input type="password" className="text-in" placeholder="Enter password" required onBlur={e=>setUserData({...userData, password:e.target.value.trim()})}
                   onChange={e=>setUserData({...userData, password:e.target.value})} value={userData.password}/>
            </div>
            <br />
            {!clicked && <button type="submit" className="login-btn">Sign in</button>}
            {clicked && <button type="submit" className="login-btn" disabled>Signing...</button>}
          </form>
      </div>
      </div></div>
      {/* <div className="d-flex justify-content-evenly navigation-links">
        <Link to="/super-admin">
          <div className="link-box">
            Super Admin
          </div>
        </Link>

        <Link to="/school-district">
          <div className="link-box">District Admin</div>
        </Link>
        <Link to="/schools">
          <div className="link-box">School Admin</div>
        </Link>

        <Link to="/teachers"><div className="link-box">Teachers</div></Link>
      </div> */}
    </div>
  )
}

export default Home

